import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useTutorKanbanStore } from './store'

interface MainInfoVideoRecordingsReturn {
  refValue: ComputedRef<string>
}

export const useMainInfoVideoRecordings = (): MainInfoVideoRecordingsReturn => {
  const tutorKanbanStore = useTutorKanbanStore()

  const refValue = computed<string>(() => `${tutorKanbanStore.getTutor?.video_recordings ?? 'All'} / week`)

  return {
    refValue,
  }
}
